$ = require('jquery')
require('../lib/headroom')

module.exports =
	init: (payload) ->
		{$target} = payload

		isTouch = $('html').hasClass('touch')

		# sticky
		$header = $('.header-fixed-wrap');
		$document = $(document)

		if $header.length
			$(window).on('scroll', ->
				if $document.scrollTop() > 60
					$header.addClass('is-fixed')
				else
					$header.removeClass('is-fixed')
			)

			header = document.querySelector('.header')
			headroom = new Headroom document.querySelector('.header'),
				tolerance: 10
				offset: 200

			headroom.init()

		# toggles
		$(document)
			# responzive search
			.on('click', '.header__search__label', (e) ->
				e.preventDefault()

				$(this).closest('.header__search').toggleClass('is-open')
					.find('.inp-text').focus()
			)
			# keyboard
			.on('focus', '.header__menu-main .header__menu__primary__link, .header__menu-main .header__menu__secondary__link', (e) ->
				unless isTouch
					$this = $(@)
					$closest = $this.closest('.header__menu__primary__item')

					$('.header__menu__primary__item').not( $closest ).removeClass('is-hover')
					$closest.addClass('is-hover')
					$(this).closest('.header__menu').removeClass('is-open')
			)
			.on('focusout', '.header__menu-main .header__menu__primary__link, .header__menu-main .header__menu__subbox a, .header__menu-main .header__menu__submenu__link', (e) ->
				unless isTouch
					unless $( e.relatedTarget ).closest('.header__menu-main').length
						$this = $(@)
						$closest = $this.closest('.header__menu__primary__item')

						$closest.removeClass('is-hover')

			)
			# touch double click
			.on('click', '.header__menu-main .header__menu__primary__item .header__menu__primary__link', (e) ->
				if isTouch
					e.preventDefault()

					$this = $(@)
					$closest = $this.closest('.header__menu__primary__item')

					$('.header__menu__primary__item').not( $closest ).removeClass('is-hover')

					if $closest.hasClass('is-hover')
						window.location = $this.attr('href')
					else
						$closest.addClass('is-hover')
			)
			# responzive menu
			.on('click', '.header__menu__title', (e) ->
				e.preventDefault()

				$(this).closest('.header__menu').toggleClass('is-open')
				$('.header__menu__primary__item').removeClass('is-hover')
			)
			.on('click touchstart', (e) ->
				unless $(e.target).closest('.header__menu-toggle, .header__menu__title').length
					$('.header__menu').removeClass('is-open')
				if isTouch && not $(e.target).closest('.header__menu-main').length
					$('.header__menu__primary__item').removeClass('is-hover')
			)
			# submenu & subbox open
			.on('click', '.header__menu__primary__toggle', (e) ->
				e.preventDefault()

				$closest = $(this).closest('.header__menu__primary__item')
				$closest.toggleClass('is-open')

				if $closest.hasClass('with-subbox') # only subbox
					$(this).closest('.header__menu-toggle')
						.css('min-height', $closest.find('.header__menu__subbox').outerHeight() )
			)
			# subbox close
			.on('click', '.header__menu__subbox__close', (e) ->
				e.preventDefault()

				$(this).closest('.header__menu__primary__item').removeClass('is-open')
				$(this).closest('.header__menu-toggle').css('min-height', 0)
			)
			# subbox items
			.on('click', '.header__menu__subbox__title__toggle', (e) ->
				e.preventDefault()

				$this = $(this)

				$this.closest('.header__menu__subbox__toggle').toggleClass('is-open')

				$this.closest('.header__menu-toggle')
					.css('min-height', 0)
					.css('min-height', $this.closest('.header__menu__subbox').outerHeight() )
			)



/** WEBPACK FOOTER **
 ** ./src/js/components/header.coffee
 **/